import { render, staticRenderFns } from "./body.vue?vue&type=template&id=c0fd4db4&scoped=true&"
import script from "./body.vue?vue&type=script&lang=js&"
export * from "./body.vue?vue&type=script&lang=js&"
import style0 from "./body.vue?vue&type=style&index=0&id=c0fd4db4&lang=less&scoped=true&"
import style1 from "./body.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fd4db4",
  null
  
)

export default component.exports